import React, {useEffect, useContext} from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
import {UserContext} from './../../../context/User'
export default function WTextField({data, onChange, tabActive}) {
  const ctxUser = useContext(UserContext)
  useEffect(() => {
    onChange({}, data.key, ctxUser.details.email)

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctxUser, data])
  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <TextField
        id="outlined-adornment-amount"
        value={data.value}
        type={'text'}
        labelWidth={60}
        label={data.name}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <FormHelperText>
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </FormControl>
  )
}
